import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import PaymentList from "./paymentList";
import { getpaymentModesApi } from "../../../api/paymentMode";
import { AddEditPayment } from "./AddEditPayment";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Payment = () => {
  const [openPayment, setOpenPayment] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedPaymentMode, setPaginatedPaymentMode] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getPaymentMode({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedPaymentMode(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getPaymentMode({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedPaymentMode(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getPaymentMode({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedPaymentMode(res.data);
    });
  };

  const getPaymentMode = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await PaymentModeMutation(params);
  };

  const { mutateAsync: PaymentModeMutation, isLoading: isPaymentModeLoading } =
    useMutation("payment", getpaymentModesApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenPayment(true)} />
        </Col>
        <Col span={24}>
          <PaymentList
            PaymentModeMutation={PaymentModeMutation}
            page={page}
            setPage={setPage}
            filter={filter}
            search={search}
            paginatedPaymentMode={paginatedPaymentMode}
            setPaginatedPaymentMode={setPaginatedPaymentMode}
            isPaymentModeLoading={isPaymentModeLoading}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      {openPayment && (
        <AddEditPayment
          openPayment={openPayment}
          setOpenPayment={setOpenPayment}
          page={page}
          filter={filter}
          search={search}
          PaymentModeMutation={PaymentModeMutation}
          setPaginatedPaymentMode={setPaginatedPaymentMode}
        />
      )}
    </>
  );
};

export default Payment;
